import { render, staticRenderFns } from "./PostSaleBumps.vue?vue&type=template&id=10c49238"
import script from "./PostSaleBumps.vue?vue&type=script&lang=js"
export * from "./PostSaleBumps.vue?vue&type=script&lang=js"
import style0 from "./PostSaleBumps.vue?vue&type=style&index=0&id=10c49238&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports